import { BrowserRouter, Routes, Route } from 'react-router-dom';
import React,{ useState } from 'react';
import Home from './pages/Home';
import About from './pages/About';
import Error from './pages/Error';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import ProtectedRoute from './pages/ProtectedRoute';
import ReportPrint from './pages/Reports/ReportPrint';
import Layout from './pages/layout/Layout';
import Contact from './pages/Contact';
import ReportLayout from './pages/Reports/ReportLayout';

export default function App() {
  const [user, setUser] = useState(null);
  return (
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<Layout />}>
        <Route index element={<Home />} />
        <Route path='about' element={<About />} />
        <Route path='ReportPrint' element={<ReportPrint />}/>
        <Route path='contact' element={<Contact />} />
       
        <Route path='login' element={<Login setUser={setUser}></Login>} />
        <Route
          path='dashboard'
          element={
            <ProtectedRoute user={user}>
              <Dashboard user={user} />
            </ProtectedRoute>
          }
        />
        <Route path='*' element={<Error />} />
      </Route>
      <Route path='/layout' element={<ReportLayout />} >
      
      </Route>
    </Routes>
  </BrowserRouter>
  )
}


